/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Nav_Stock_Out_NotesInputs */

const vi_pl_nav_stock_out_notes = /** @type {(inputs: Pl_Nav_Stock_Out_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách PXK`)
};

/**

* @param {Pl_Nav_Stock_Out_NotesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_nav_stock_out_notes = /** @type {((inputs?: Pl_Nav_Stock_Out_NotesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Nav_Stock_Out_NotesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_nav_stock_out_notes(inputs)
});